import { NORMALIZED_EMAIL_ATTRIBUTE } from '@provision/conversation-constants';

const NORMALIZED_EMAIL_SEARCH_PATTERN = `${NORMALIZED_EMAIL_ATTRIBUTE}=`;

/*
 ** When api parses email html it wraps email content into div with a specific attribute 'data-email-service'
 ** Example: `<div style="display: inline-grid;" data-email-service="apple">Messsage</div>
 ** This is used to identify if email message was processed and should be displayed following
 ** application styles.
 */
export function isEmailMessageShouldBeDisplayedUnstyled(content: string): boolean {
  return content.includes(NORMALIZED_EMAIL_SEARCH_PATTERN);
}

export const isFullDocument = (html: string): boolean => {
  return /<!doctype html>|<html[\s>|<body>|<head>|<style>]/i.test(html);
};
